import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { createPriceFormatterMemoized } from "@plansoft-configuration-renderer/localization";
/**
 * Renders price of the value
 * @param props
 * @returns
 */
export function ValueOptionPrice(props) {
    const currencyFormatter = createPriceFormatterMemoized({
        localeCode: props.locale,
        currencyInfo: props.currencyInfo,
    });
    return (_jsx(Typography, { sx: props.sx, children: currencyFormatter(props.price) }));
}
//# sourceMappingURL=ValueOptionPrice.js.map